var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 6,
    viewBox: "0 0 5 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.935917 5.62817C0.769694 5.62817 0.627694 5.56931 0.509917 5.45158C0.392194 5.33381 0.333333 5.19181 0.333333 5.02558V0.794833H0V0.294833H1.5V0H3.5V0.294833H5V0.794833H4.66667V5.02558C4.66667 5.19397 4.60833 5.3365 4.49167 5.45317C4.375 5.56983 4.23247 5.62817 4.06408 5.62817H0.935917ZM4.16667 0.794833H0.833333V5.02558C0.833333 5.05553 0.842944 5.08011 0.862167 5.09933C0.881389 5.11856 0.905972 5.12817 0.935917 5.12817H4.06408C4.08975 5.12817 4.11325 5.11747 4.13458 5.09608C4.15597 5.07475 4.16667 5.05125 4.16667 5.02558V0.794833ZM1.63467 4.4615H2.13458V1.4615H1.63467V4.4615ZM2.86542 4.4615H3.36533V1.4615H2.86542V4.4615Z",
    fill: "#15182C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4d2930e0ee5fc2fe54a9e7aa9d5e9fcd.svg";
export { ForwardRef as ReactComponent };